/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

import React from 'react';
import PropTypes from 'prop-types';
import errorIllustration from './assets/error-illustration.svg';
import {ActionButton} from '../index';
import SupportDetails from 'components/SupportDetails';

const propTypes = {
  children: PropTypes.node,
  imageUrl: PropTypes.string,
  message: PropTypes.string,
  className: PropTypes.string,
};

const defaultProps = {
  imageUrl: errorIllustration,
  message: 'Oops! Something went wrong, Please close the window and retry after sometime.',
};

const Error = ({children, imageUrl, message, className = ''}) => (
  <div
    className={`w-100 h-100 d-flex px-3 flex-column justify-content-center align-items-center ${className}`}
  >
    <div>
      <img alt="ERROR" height={160} width={160} className="error-image" src={imageUrl} />
    </div>
    <div className="d-flex flex-column align-items-center text-grey">
      <p className="mt-1 mb-2 lead">{message}</p>
    </div>
    {children ? (
      children
    ) : (
      <ActionButton
        buttonText={'Retry Now'}
        callback={() => {
          window?.location?.reload();
        }}
        isDisabled={false}
        additionalStyles={{maxWidth: '480px'}}
        className="mt-5 body-regular"
      />
    )}
    <SupportDetails wrapperClassName="mt-5" hideMobile />
  </div>
);

Error.propTypes = propTypes;
Error.defaultProps = defaultProps;

export default Error;
